import { AnchorLinkMeta, Fragment, ImageMeta } from '@openlaw-au/types';
import { FunctionComponent } from 'react';

interface Props {
  frags: Fragment[];
}

const FragmentRenderer: FunctionComponent<Props> = ({ frags }) => (
  <span>
    {frags.map((frag, idx) => {
      let el = null;
      switch (frag.type) {
        case 'Normal': {
          el = (
            <span key={idx}>
              {frag.text}
              <FragmentRenderer frags={frag.fragments} />
            </span>
          );
          break;
        }
        case 'Strong': {
          el = (
            <b key={idx}>
              {frag.text}
              <FragmentRenderer frags={frag.fragments} />
            </b>
          );
          break;
        }
        case 'Emphasis': {
          el = (
            <em key={idx}>
              {frag.text}
              <FragmentRenderer frags={frag.fragments} />
            </em>
          );
          break;
        }
        case 'Underline': {
          el = (
            <ul key={idx}>
              <FragmentRenderer frags={frag.fragments} />
            </ul>
          );
          break;
        }
        case 'SuperScript': {
          el = (
            <sup key={idx}>
              <FragmentRenderer frags={frag.fragments} />
            </sup>
          );
          break;
        }
        case 'SubScript': {
          break;
        }
        case 'Anchor': {
          el = (
            <a
              key={idx}
              href={
                (frag.meta[0] as { AnchorElementMeta: AnchorLinkMeta })
                  .AnchorElementMeta.href
              }
              className="text-jade-primary underline underline-offset-4 hover:decoration-jade-primary hover:decoration-2 subpixel-antialiased transition duration-200"
            >
              <FragmentRenderer frags={frag.fragments} />
            </a>
          );
          break;
        }
        case 'LineBreak':
          break;
        case 'Span':
          el = (
            <span key={idx} className="bg-beautiful-green">
              {frag.text}
              <FragmentRenderer frags={frag.fragments} />
            </span>
          );
          break;
        case 'Image':
          el = (
            <img
              key={idx}
              src={`https://jade.io${
                (frag.meta[0] as { ImageElementMeta: ImageMeta })
                  .ImageElementMeta.src
              }`}
            />
          );
          break;
        default:
          break;
      }
      return el;
    })}
  </span>
);

export default FragmentRenderer;
